import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteGoalsGoalDetailsWCEval } from './DetailsWCEval';
import { PatientCareCenterNoteGoalsGoalDetailsWCDN } from './DetailsWCDN';
import { PatientCareCenterNoteGoalsGoalDetailsWCDelete } from './DetailsWCDelete';
import { PatientCareCenterNoteGoalsGoalDetailsWCPN } from './DetailsWCPN';
import { PatientCareCenterNoteGoalsGoalDetailsWCDC } from './DetailsWCDC';
import { PatientCareCenterNoteGoalsGoalDetailsWCFreeForm } from './DetailsWCFreeForm';
import { PatientCareCenterNoteGoalsGoalDetailsWCEvalCustom } from './DetailsWCEvalCustom';
import { PatientCareCenterNoteGoalsGoalDetailsWCDNCustom } from './DetailsWCDNCustom';
import { PatientCareCenterNoteGoalsGoalDetailsWCPNCustom } from './DetailsWCPNCustom';
import { PatientCareCenterNoteGoalsGoalDetailsWCDCCustom } from './DetailsWCDCCustom';

class PatientCareCenterNoteGoalsGoalDetailsWC extends React.Component {

    render() {
        if (this.props.isFreeForm && !this.props.goal.GODELETED) {
            return (<PatientCareCenterNoteGoalsGoalDetailsWCFreeForm id={this.props.id} />);
        } else if (this.props.noteType === 1 && !this.props.isCustom) { // eval
            return (<PatientCareCenterNoteGoalsGoalDetailsWCEval id={this.props.id} />);
        } else if (this.props.noteType === 1 && this.props.isCustom) { // eval
            return (<PatientCareCenterNoteGoalsGoalDetailsWCEvalCustom id={this.props.id} />);
        } else if (this.props.noteType === 2 && !this.props.isCustom) { // DN
            return (<PatientCareCenterNoteGoalsGoalDetailsWCDN id={this.props.id} />);
        } else if (this.props.noteType === 2 && this.props.isCustom) { // DN
            return (<PatientCareCenterNoteGoalsGoalDetailsWCDNCustom id={this.props.id} />);
        } else if ((this.props.noteType === 3 || this.props.noteType === 5) && this.props.goal.GODELETED) { // PN with deleted set
            return (<PatientCareCenterNoteGoalsGoalDetailsWCDelete id={this.props.id} />);
        } else if ((this.props.noteType === 3 || this.props.noteType === 5) && !this.props.isCustom) { // PN
            return (<PatientCareCenterNoteGoalsGoalDetailsWCPN id={this.props.id} />);
        } else if ((this.props.noteType === 3 || this.props.noteType === 5) && this.props.isCustom) { // PN
            return (<PatientCareCenterNoteGoalsGoalDetailsWCPNCustom id={this.props.id} />);
        } else if ((this.props.noteType === 4 || this.props.noteType === 6) && !this.props.isCustom) {
            return (<PatientCareCenterNoteGoalsGoalDetailsWCDC id={this.props.id} />);
        } else if ((this.props.noteType === 4 || this.props.noteType === 6) && this.props.isCustom) {
            return (<PatientCareCenterNoteGoalsGoalDetailsWCDCCustom id={this.props.id} />);
        } else {
            return (<span />);
        }
    }
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let goal = state.entities.notes.PTGOALS[ownprops.id];
    let isFreeForm = goal.GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_FREE_FORM_GOAL_ID'].PRVALUE) ? true : false;
    let isCustom = goal.GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID_WC'].PRVALUE) ? true : false;

    return {
        noteId,
        noteType,
        pk,
        goal,
        isFreeForm,
        isCustom
    };
}

const connectedPatientCareCenterNoteGoalsGoalDetailsWC = connect(mapStateToProps)(PatientCareCenterNoteGoalsGoalDetailsWC);
export { connectedPatientCareCenterNoteGoalsGoalDetailsWC as PatientCareCenterNoteGoalsGoalDetailsWC };

